<template>
  <div>
    <b-tabs content-class="mt-1">
      <b-tab title="Account">
        <b-form @submit.prevent>
          <b-row>

            <!-- first name -->
            <b-col cols="12">
              <b-form-group
                label="First Name"
                label-for="vi-first-name"
              >
                <b-input-group class="input-group-merge">
                  <b-input-group-prepend is-text>
                    <feather-icon icon="UserIcon" />
                  </b-input-group-prepend>
                  <b-form-input
                    id="vi-first-name"
                    v-model="account.firstName"
                    placeholder="First Name"
                  />
                </b-input-group>
              </b-form-group>
            </b-col>

            <b-col cols="12">
              <b-form-group
                label="Last Name"
                label-for="vi-last-name"
              >
                <b-input-group class="input-group-merge">
                  <b-input-group-prepend is-text>
                    <feather-icon icon="UserIcon" />
                  </b-input-group-prepend>
                  <b-form-input
                    id="vi-last-name"
                    v-model="account.lastName"
                    placeholder="Last Name"
                  />
                </b-input-group>
              </b-form-group>
            </b-col>

            <!-- email -->
            <b-col cols="12">
              <b-form-group
                label="Email"
                label-for="vi-email"
              >
                <b-input-group class="input-group-merge">
                  <b-input-group-prepend is-text>
                    <feather-icon icon="MailIcon" />
                  </b-input-group-prepend>
                  <b-form-input
                    id="vi-email"
                    v-model="account.email"
                    type="email"
                    placeholder="Email"
                  />
                </b-input-group>
              </b-form-group>
            </b-col>

            <!-- mobile -->
            <b-col cols="12">
              <b-form-group
                label="Mobile"
                label-for="vi-mobile"
              >
                <b-input-group class="input-group-merge">
                  <b-input-group-prepend is-text>
                    <feather-icon icon="SmartphoneIcon" />
                  </b-input-group-prepend>
                  <b-form-input
                    id="vi-mobile"
                    v-model="account.mobile"
                    placeholder="Mobile"
                  />
                </b-input-group>
              </b-form-group>
            </b-col>

            <!-- password -->
            <b-col cols="12">
              <b-form-group
                label="Password"
                label-for="vi-password"
              >
                <b-input-group class="input-group-merge">
                  <b-input-group-prepend is-text>
                    <feather-icon icon="LockIcon" />
                  </b-input-group-prepend>
                  <b-form-input
                    id="vi-password"
                    v-model="account.password"
                    placeholder="Password"
                  />
                </b-input-group>
              </b-form-group>
            </b-col>

            <b-col cols="12">
              <b-form-group
                label="Max Devices"
                label-for="vi-max-devices"
              >
                <b-input-group class="input-group-merge">
                  <b-input-group-prepend is-text>
                    <feather-icon icon="CpuIcon" />
                  </b-input-group-prepend>
                  <b-form-input
                    id="vi-max-devices"
                    v-model="account.maxEnabledDevices"
                    placeholder="Max Devices"
                  />
                </b-input-group>
              </b-form-group>
            </b-col>
            <!-- checkbox -->
            <b-col cols="12">
              <b-form-group>
                <b-form-checkbox
                  id="checkbox-4"
                  v-model="account.emailValidated"
                  name="checkbox-4"
                  value="true"
                >
                  Email validated
                </b-form-checkbox>
              </b-form-group>
            </b-col>

            <!-- checkbox -->
            <b-col cols="12">
              <b-form-group>
                <b-form-checkbox
                  id="author"
                  v-model="account.author"
                  name="author"
                  value="true"
                >
                  Author ( Access Web Content Editor)
                </b-form-checkbox>
              </b-form-group>
            </b-col>

            <!-- checkbox -->
            <b-col cols="12">
              <b-form-group>
                <b-form-checkbox
                  id="accountEnabled"
                  v-model="account.status"
                  name="accountEnabled"
                  value="ENABLED"
                  unchecked-value="DISABLED"
                >
                  Enabled (Account status)
                </b-form-checkbox>
              </b-form-group>
            </b-col>

            <b-col cols="12">
              <div style="padding-bottom: 10px">
                <span style="font-weight: bold;padding-bottom: 10px">Created At: {{ formatDate(account.created) }}</span>
                <br> Last Login: {{ formatDate(account.lastLoggedIn) }} ( {{ account.lastAccessedPlatform }} ) , Last Accessed: {{ formatDate(account.lastAccessed) }} ( {{ account.lastAccessedPlatform }} )
              </div>
            </b-col>

            <!-- firebase uid -->
            <b-col cols="12">
              <div style="padding-bottom: 10px">
                <span style="padding-bottom: 10px">Firebase UID: {{ account.firebaseUID }}</span>
              </div>
            </b-col>

            <!-- reset and submit -->
            <div class="demo-inline-spacing">
              <b-button
                v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                type="submit"
                variant="primary"
                class="mr-1"
                @click="askSaveAccount"
              >
                Save
              </b-button>

              <b-button
                v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                type="submit"
                variant="danger"
                class="mr-1"
                @click="askDelete"
              >
                Delete
              </b-button>

              <b-button
                v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                v-b-modal.modal-grant-book
                type="submit"
                variant="success"
                class="mr-1"
              >
                Grant Book
              </b-button>

              <b-button
                v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                v-b-modal.modal-migrate-books
                type="submit"
                variant="danger"
                class="mr-1"
              >
                Migrate Books !!!
              </b-button>
            </div>
          </b-row>
        </b-form>
      </b-tab>

      <b-tab title="Purchases">
        <DataTable
          :api="purchasesUrl"
          :on-row-selected-callback="onPurchaseSelected"
        />
      </b-tab>

      <b-tab title="Devices">
        <DataTable
          :api="devicesUrl"
          :on-row-selected-callback="onDeviceSelected"
        />
      </b-tab>

      <b-tab
        title="NIC Entitlements"
        lazy
      >
        <DataTable
          :api="nicEntitlementsUrl"
          :columns="nicEntitlementColumns"
        />
      </b-tab>
    </b-tabs>

    <b-modal
      id="modal-grant-book"
      cancel-variant="outline-secondary"
      ok-title="Grant Book"
      cancel-title="Close"
      centered
      title="Grant Book"
      @ok="grantBook"
    >
      <b-form>
        <b-form-group>
          <label for="booId">Book:</label>
          <vue-autosuggest
            :suggestions="filteredOptions"
            :limit="25"
            :get-suggestion-value="getSuggestionValue"
            :input-props="{id:'autosuggest__input',class:'form-control', placeholder:'Search by Title or Author'}"
            @input="onInputChange"
          >
            <template slot-scope="{suggestion}">
              <b-row
                style="z-index: 4444;cursor: pointer"
                @mouseup="onSelected(suggestion.item)"
              >
                <b-col>
                  <img
                    style="max-width: 70px"
                    :src="suggestion.item.image"
                  >
                  {{ suggestion.item.title }}
                </b-col>
              </b-row>
            </template>
          </vue-autosuggest>
        </b-form-group>
      </b-form>
    </b-modal>

    <b-modal
      id="modal-migrate-books"
      cancel-variant="outline-secondary"
      ok-title="OK"
      cancel-title="Close"
      centered
      title="Move Books"
      @ok="askAccountMigration"
    >
      <b-form>
        <b-form-group>
          <b-col cols="12">
            <b-form-group
              label="Email"
              label-for="vi-to-email"
            >
              <b-input-group class="input-group-merge">
                <b-input-group-prepend is-text>
                  <feather-icon icon="UserIcon" />
                </b-input-group-prepend>
                <b-form-input
                  id="vi-to-email"
                  v-model="toEmail"
                  placeholder="Target Account Email"
                />
              </b-input-group>
            </b-form-group>
          </b-col>
        </b-form-group>
      </b-form>
    </b-modal>

  </div>
</template>

<script>
import DataTable from '@core/components/data-table/DataTable.vue'
import axios from 'axios'
import firebase from 'firebase/app'
import 'firebase/auth'
import {
  BRow, BCol, BFormGroup, BFormInput, BFormCheckbox, BForm, BButton, BInputGroup, BInputGroupPrepend, BTabs, BTab,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import { VueAutosuggest } from 'vue-autosuggest'

export default {
  components: {
    DataTable,
    BRow,
    BCol,
    BFormGroup,
    BFormInput,
    BFormCheckbox,
    BInputGroup,
    BInputGroupPrepend,
    BForm,
    BButton,
    BTabs,
    BTab,
    VueAutosuggest,
  },
  directives: {
    Ripple,
  },
  data() {
    return {
      account: {},
      purchasesUrl: `/admin/accounts/${this.$route.params.email}/purchases`,
      devicesUrl: `/admin/accounts/${this.$route.params.email}/devices`,
      nicEntitlementsUrl: `/admin/accounts/${this.$route.params.email}/nic-entitlements`,
      nicEntitlementColumns: [
        { key: 'forwardChessId', label: 'ForwardChess ID' },
        { key: 'granted', label: 'Granted' },
        { key: 'isConverted', label: 'Is Converted' },
        { key: 'productId', label: 'Product ID' },
      ],
      grantBookId: undefined,
      datasuggest: [],
      debounceMilliseconds: 250,
      timeout: null,
      filteredOptions: [],
      limit: 10,
      selected: null,
      toEmail: null,
    }
  },
  mounted() {
    const url = `${this.$readerURL}/admin/accounts/${this.$route.params.email}`
    firebase.auth().currentUser.getIdToken(false).then(idToken => {
      axios.get(url,
        {
          headers: {
            Authorization: idToken,
          },
        }).then(response => {
        this.account = response.data
        return response
      }).catch(error => {
        // eslint-disable-next-line no-console
        console.log(error)
        this.$bvModal
          .msgBoxOk('Account not found!', {
            title: 'Info',
            size: 'sm',
            okVariant: 'danger',
            okTitle: 'Close',
            hideHeaderClose: false,
            centered: true,
          })
          .then(() => {
            this.$router.push('/')
          })
      })
    })
  },
  methods: {
    getSuggestionValue(suggestion) {
      return suggestion.item.title
    },
    onInputChange(text) {
      if (text === '' || text === undefined) {
        this.filteredOptions = []
        return
      }

      const url = `${this.$readerURL}/admin/books/search?keyword=${text}`
      clearTimeout(this.timeout)
      const temp = this
      this.timeout = setTimeout(() => {
        firebase.auth().currentUser.getIdToken(false).then(idToken => {
          axios.get(url,
            {
              headers: {
                Authorization: idToken,
              },
            }).then(response => {
            const books = []
            response.data.forEach(element => books.push(element))
            temp.filteredOptions = [{ data: books }]
            return response
          }).catch(error => error)
        })
      }, this.debounceMilliseconds)
    },
    onSelected(event) {
      this.grantBookId = event.sku
    },
    grantBook() {
      const grant = {
        bookId: this.grantBookId,
        email: this.$route.params.email,
      }
      const url = `${this.$readerURL}/admin/purchases`
      // Remove initial loading
      this.loader('block')
      firebase.auth().currentUser.getIdToken(false).then(idToken => {
        axios.post(url, grant,
          {
            headers: {
              Authorization: idToken,
            },
          }).then(response => {
          this.grantBookId = undefined
          this.loader('none')
          this.$toast({
            component: ToastificationContent,
            props: {
              title: 'success',
              icon: 'EditIcon',
              variant: 'success',
            },
          })
          return response
        }).catch(error => {
          this.loader('none')
          this.$toast({
            component: ToastificationContent,
            props: {
              title: error,
              icon: 'EditIcon',
              variant: 'error',
            },
          })
        })
      })
    },
    askDelete() {
      this.$bvModal
        .msgBoxConfirm('Please confirm that you want to delete this account?.', {
          title: 'Please Confirm',
          size: 'sm',
          okVariant: 'danger',
          okTitle: 'Delete',
          cancelTitle: 'Cancel',
          cancelVariant: 'outline-secondary',
          hideHeaderClose: false,
          centered: true,
        })
        .then(value => {
          if (value) {
            this.deleteAccount()
          }
        })
    },
    askAccountMigration() {
      this.$bvModal
        .msgBoxConfirm(`Please confirm that you want to move books to ${this.toEmail}`, {
          title: 'Please Confirm',
          size: 'sm',
          okVariant: 'danger',
          okTitle: 'Move Books',
          cancelTitle: 'Cancel',
          cancelVariant: 'outline-secondary',
          hideHeaderClose: false,
          centered: true,
        })
        .then(value => {
          if (value) {
            this.migrateAccount()
          }
        })
    },
    askSaveAccount() {
      this.$bvModal
        .msgBoxConfirm('Please confirm that you want to save account details.', {
          title: 'Please Confirm',
          size: 'sm',
          okVariant: 'primary',
          okTitle: 'Save',
          cancelTitle: 'Cancel',
          cancelVariant: 'outline-secondary',
          hideHeaderClose: false,
          centered: true,
        })
        .then(value => {
          if (value) {
            this.saveAccount()
          }
        })
    },
    deleteAccount() {
      const url = `${this.$readerURL}/admin/accounts/${this.$route.params.email}`
      this.loader('block')
      firebase.auth().currentUser.getIdToken(false).then(idToken => {
        axios.delete(url,
          {
            headers: {
              Authorization: idToken,
            },
          }).then(response => {
          this.loader('none')
          this.$router.push('/')
          this.$toast({
            component: ToastificationContent,
            props: {
              title: 'success',
              icon: 'EditIcon',
              variant: 'success',
            },
          })
          return response
        }).catch(error => {
          this.loader('none')
          this.$toast({
            component: ToastificationContent,
            props: {
              title: error,
              icon: 'EditIcon',
              variant: 'error',
            },
          })
        })
      })
    },
    showMigrationDone(fromEmail, toEmail) {
      const h = this.$createElement
      const message = h('div', [
        h('p', [`Books and settings were moved from ${fromEmail} to ${toEmail}.`]),
        h('p', { class: 'font-weight-bold' }, [
          `${fromEmail} has NOT been deleted. If it is no longer needed, delete it manually with the Delete button on this page.`,
        ]),
        h('p', [
          'Before deleting, check the new account has the books. Deleting also closes any website account for ',
          `${fromEmail} and blocks that email from registering again.`,
        ]),
      ])
      this.$bvModal
        .msgBoxConfirm([message], {
          title: 'Books moved',
          size: 'md',
          okVariant: 'primary',
          okTitle: 'View new account',
          cancelTitle: 'Close',
          cancelVariant: 'outline-secondary',
          centered: true,
        })
        .then(value => {
          if (value) {
            // new tab: this page loads its data once, and keeps this account's Delete button at hand
            const { href } = this.$router.resolve(`/accounts/${encodeURIComponent(toEmail)}`)
            window.open(href, '_blank')
          }
        })
    },
    migrateAccount() {
      const url = `${this.$readerURL}/admin/accounts/migrate`
      this.loader('block')
      const migrate = {
        fromEmail: this.$route.params.email,
        toEmail: this.toEmail,
      }
      firebase.auth().currentUser.getIdToken(false).then(idToken => {
        axios.post(url, migrate,
          {
            headers: {
              Authorization: idToken,
            },
          }).then(response => {
          this.loader('none')
          this.showMigrationDone(migrate.fromEmail, migrate.toEmail)
          return response
        }).catch(error => {
          this.loader('none')
          this.$toast({
            component: ToastificationContent,
            props: {
              title: error,
              icon: 'EditIcon',
              variant: 'error',
            },
          })
        })
      })
    },
    onDeviceSelected(row) {
      this.$router.push(`/accounts/${this.$route.params.email}/devices/${row[0].id}`)
    },
    onPurchaseSelected(row) {
      this.$router.push(`/accounts/${this.$route.params.email}/purchases/${row[0].productId}`)
    },
    saveAccount() {
      const url = `${this.$readerURL}/admin/accounts/${this.$route.params.email}`
      this.loader('block')
      firebase.auth().currentUser.getIdToken(false).then(idToken => {
        axios.post(url, this.account,
          {
            headers: {
              Authorization: idToken,
            },
          }).then(response => {
          this.loader('none')
          this.$toast({
            component: ToastificationContent,
            props: {
              title: 'success',
              icon: 'EditIcon',
              variant: 'success',
            },
          })
          return response
        }).catch(error => {
          this.loader('none')
          this.$toast({
            component: ToastificationContent,
            props: {
              title: error,
              icon: 'EditIcon',
              variant: 'error',
            },
          })
        })
      })
    },
  },
}
</script>

<style>
#autosuggest__input {
  outline: none;
  position: relative;
  display: block;
  font-family: monospace;
  font-size: 20px;
  border: 1px solid #616161;
  padding: 10px;
  width: 100%;
  box-sizing: border-box;
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
}

#autosuggest__input.autosuggest__input-open {
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
}

.autosuggest__results-container {
  position: relative;
  width: 100%;
}

.autosuggest__results {
  position: absolute;
  z-index: 10000001;
  color: black;
  font-weight: bold;
  width: 100%;
  border: 1px solid #e0e0e0;
  border-bottom-left-radius: 4px;
  border-bottom-right-radius: 4px;
  background: white;
  overflow-y: scroll;
  max-height: 500px;
}

::-webkit-scrollbar {
  width: 10px;
}

::-webkit-scrollbar-thumb {
  background: rgba(0, 0, 0, .6);
}

.autosuggest__results ul {
  list-style: none;
  padding: 10px;
  margin: 0;
}

.autosuggest__results li {
  list-style: none;
  padding: 10px;
  margin: 0;
}

.autosuggest__results .autosuggest__results_item {
  cursor: pointer;
  padding: 15px;
}

#autosuggest ul:nth-child(1) > .autosuggest__results_title {
  border-top: none;
}

.autosuggest__results .autosuggest__results_title {
  font-size: 12px;
  margin-left: 0;
  padding: 15px 13px 5px;
  border-top: 1px solid lightgray;
}
.autosuggest__results .autosuggest__results_item {
  cursor: pointer;
  padding: 15px;
}

#autosuggest ul:nth-child(1) > .autosuggest__results_title {
  border-top: none;
}

.autosuggest__results .autosuggest__results_title {
  color: gray;
  font-size: 11px;
  margin-left: 0;
  padding: 15px 13px 5px;
  border-top: 1px solid lightgray;
}

.autosuggest__results .autosuggest__results_item:active,
.autosuggest__results .autosuggest__results_item:hover,
.autosuggest__results .autosuggest__results_item:focus,
.autosuggest__results .autosuggest__results_item.autosuggest__results_item-highlighted {
  background-color: #ddd;
}

</style>
